import { routes } from '@/app/routing/router'
import { DailyBonusView } from './view'

const currentRoute = routes.dailyBonus

const DailyBonusRoute = {
  view: DailyBonusView,
  route: currentRoute,
}

export { currentRoute, DailyBonusRoute }
